<template>
  <seckill-popup class="seckill-book-popup-component"
                 :show.sync="visible"
                 :show-close-btn="false"
  >
    <div class="seckill-book-popup-content">
      <div class="seckill-book-popup-title">
        离预约只差一步了哦
      </div>
      <div class="seckill-book-popup-mobile">
        <div class="seckill-book-popup-mobile-hint">
          请输入手机号
        </div>
        <input class="seckill-book-popup-mobile-input"
               v-model="value"
               title="请输入手机号"
               type="text"
        >
      </div>
      <div class="seckill-book-popup-buttons">
        <ym-button class="seckill-book-popup-button seckill-book-popup-button--highlight"
                   round
                   @click="handleBook"
        >
          继续预约活动
        </ym-button>
        <ym-button class="seckill-book-popup-button seckill-book-popup-button--gray"
                   round
                   @click="handleClose"
        >
          不了，谢谢
        </ym-button>
      </div>
    </div>
  </seckill-popup>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import SeckillPopup from '@/pages/Seckill/components/SeckillPopup';
  import { bookSeckillWithMobile } from '@/services/seckill';
  import validator from '@/utils/validator';

  export default {
    name: 'SeckillBookPopup',
    components: {
      'ym-button': Button,
      SeckillPopup,
    },
    data() {
      return {
        visible: false,
        value: '',
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      target: {
        type: Object,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      async handleBook() {
        if (this.value === '') {
          this.$toast('请输入手机号');
          return;
        }
        if (!validator.isMobile(this.value)) {
          this.$toast('请输入正确的手机号');
          return;
        }
        const { value: mobile, target } = this;
        await bookSeckillWithMobile({ mobile, ...target });
        this.visible = false;
        // 刷新页面
        window.location.reload();
      },
      handleClose() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @seckill-book-input-height: 66px;
  .seckill-book-popup {
    &-content {
      padding: 80px @size-large @size-medium;
      text-align: center;
      line-height: 1;
    }

    &-title {
      font-size: @font-size-large;
      margin-bottom: @size-extra-medium;
      color: @seckill-primary-1;
    }

    &-mobile {
      margin-bottom: 90px;

      &-hint {
        margin-bottom: @size-small;
        font-size: @font-size-medium;
        color: @color-text-light;
      }

      &-input {
        box-sizing: border-box;
        display: block;
        width: 100%;
        height: @seckill-book-input-height;
        margin: 0;
        padding: 0 15px 0 90px;
        font-size: @font-size-extra-large;
        outline: none;
        border: none;
        background: url("~@/assets/img/seckill/mobile_country_code.png")
                no-repeat 15px center @color-gray-lighter;
        background-size: 51px 23px;
      }

      &-code {
        display: block;
        width: 51px;
        height: 23px;
      }
    }

    &-buttons {
      padding: 0 @size-base;
    }

    &-button {
      display: block;
      width: 100%;
      margin: @size-base auto 0;

      &--highlight {
        color: @color-white;
        background: @seckill-highlight;
      }

      &--gray {
        color: @color-text-light;
        background: @color-gray-lightest;
      }
    }
  }
</style>
